
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-mynews",
      function () {
        return require("private-next-pages/about-mynews/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-mynews"])
      });
    }
  